import { RefObject, useCallback, useRef, useSyncExternalStore } from "react";

interface Dimensions {
	width: number;
	height: number;
}

const ZERO: Dimensions = { width: 0, height: 0 };

export function useViewportDimensions(ref: RefObject<HTMLElement | null>): Dimensions {
	const cacheRef = useRef<Dimensions>(ZERO);

	const subscribe = useCallback(
		(notify: () => void) => {
			const element = ref.current;
			if (!element) return () => {};
			const observer = new ResizeObserver((entries) => {
				for (const entry of entries) {
					const next = { width: entry.contentRect.width, height: entry.contentRect.height };
					if (next.width !== cacheRef.current.width || next.height !== cacheRef.current.height) {
						cacheRef.current = next;
						notify();
					}
				}
			});
			observer.observe(element);
			return () => observer.disconnect();
		},
		[ref]
	);

	const getSnapshot = useCallback(() => cacheRef.current, []);

	return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
